import { useEffect, useState } from "react";
import { FaCalendar } from "react-icons/fa6";
import { DateRangePicker } from "react-date-range";

const Header = ({
  setStartDate,
  setEndDate,
}) => {
  const [showPicker, setShowPicker] = useState(false);

  const [state, setState] = useState({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  });

  const handleSelect = (ranges) => {
    setState({
      selection: ranges.selection,
    });
  };

  const handleApply = () => {
    const start = new Date(state.selection.startDate);
    const end = new Date(state.selection.endDate);

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    setStartDate(start.toISOString());
    setEndDate(end.toISOString());

    setShowPicker(false);
  };

  return (
    <div className="analytics-header">
      <h2>Payin & Payin-Upload</h2>

      <div className="analytics-sub-head">
        <div className="header-box-cal">
          <div className="dash-head">
            <div className="pay-in-out-div">
              <p onClick={() => setShowPicker(!showPicker)}>
                Select date range:
              </p>

              <div
                className={
                  showPicker ? "selected-filter" : "filter-on-chart"
                }
                onClick={() => setShowPicker(!showPicker)}
              >
                <FaCalendar size={20} />
              </div>
            </div>
          </div>

          {showPicker && (
            <div className="picker-box">
              <div className="date-range-picker-container">
                <DateRangePicker
                  ranges={[state.selection]}
                  onChange={handleSelect}
                />

                <button
                  onClick={handleApply}
                  className="apply-button"
                >
                  Apply
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;